import vImage from "./v-image.vue";
import vImageGroup from "./v-image-group.vue";

export default Vue => {
  Vue.component("v-image", vImage);
  Vue.component("v-image-group", vImageGroup);
};
